module.exports = __webpack_public_path__ + "static/media/45.a04b0fc5.png";